import produce from "immer";

import { ModelState } from "../../../interfaces/modelState";

interface IbanMutationModel {
  iban: string;
}

interface State {
  data: Partial<IbanMutationModel>;
  loading: boolean;
  modelState: ModelState | null;
}

export const initialState: State = {
  data: {
    iban: undefined,
  },
  loading: false,
  modelState: null,
};

type Action =
  | { type: "UPDATE_BANK_ACCOUNT_MUTATION_DATA"; payload: Partial<IbanMutationModel> }
  | { type: "UPDATE_BANK_ACCOUNT_MUTATION_ERROR"; payload: ModelState }
  | { type: "UPDATE_BANK_ACCOUNT_MUTATION_FETCH_START" }
  | { type: "UPDATE_BANK_ACCOUNT_MUTATION_FETCH_ERROR"; payload: ModelState };

export const bankAccountMutationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "UPDATE_BANK_ACCOUNT_MUTATION_DATA":
      return produce(state, (draft) => {
        draft.data = { ...draft.data, ...action.payload };
      });
    case "UPDATE_BANK_ACCOUNT_MUTATION_ERROR":
      return produce(state, (draft) => {
        draft.modelState = action.payload;
      });
    case "UPDATE_BANK_ACCOUNT_MUTATION_FETCH_START":
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case "UPDATE_BANK_ACCOUNT_MUTATION_FETCH_ERROR":
      return produce(state, (draft) => {
        draft.loading = false;
        draft.modelState = action.payload;
      });
  }
};
